import router from "./routes";
import { RouterProvider } from "react-router";
import Notification from "./components/Notification";
import AuthBanner from "./components/AuthBanner";
import { useEffect } from "react";
import { useAppDispatch } from "./store/hooks";
import { setToken, setUser } from "./store/features/auth/authSlice";

function App() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    // Try to restore session from localStorage
    const savedToken = localStorage.getItem("access_token");
    const savedUser = localStorage.getItem("user");
 
    if (savedToken) {
      dispatch(setToken(savedToken));
      dispatch(setUser(savedUser));
    }
  }, [dispatch]);

  return (
    <>
      <Notification />
      <AuthBanner />
      <RouterProvider router={router} />
    </>
  );
}

export default App;
